import React from "react";
import ReactMarkdown from "react-markdown";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { RSC_PRIVACY_POLICY } from "../../constants/privacyPolicy";

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();

  return (
    <div style={{ maxWidth: 900, margin: "0 auto", padding: "32px 24px" }}>
      <style>{`
        .pp-markdown p, .pp-markdown li { color: rgba(255,255,255,0.85); margin-bottom: 16px; font-size: 15px; line-height: 1.6; }
        .pp-markdown h1 { color: #fff; margin-top: 28px; margin-bottom: 16px; font-weight: 700; font-size: 26px; }
        .pp-markdown h2 { color: #fff; margin-top: 24px; margin-bottom: 12px; font-weight: 700; font-size: 21px; }
        .pp-markdown h3 { color: #fff; margin-top: 18px; margin-bottom: 8px; font-weight: 700; font-size: 17px; }
        .pp-markdown a { color: #00ADB5; }
        .pp-markdown strong { color: rgba(255,255,255,0.92); }
        .pp-markdown hr { border: none; border-top: 1px solid rgba(255,255,255,0.12); margin: 24px 0; }
        .pp-markdown table { width: 100%; border-collapse: collapse; margin-bottom: 24px; }
        .pp-markdown th, .pp-markdown td { border: 1px solid rgba(255,255,255,0.12); padding: 8px; text-align: left; vertical-align: top; color: rgba(255,255,255,0.85); }
        .pp-markdown ul, .pp-markdown ol { padding-left: 24px; margin-bottom: 16px; }
      `}</style>
      <button
        type="button"
        onClick={() => navigate("/")}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          background: "transparent",
          border: "none",
          color: "rgba(255,255,255,0.54)",
          fontSize: 13,
          cursor: "pointer",
          padding: 0,
          marginBottom: 24,
        }}
      >
        <ArrowLeft size={15} /> Back
      </button>

      <div className="pp-markdown">
        <ReactMarkdown>{RSC_PRIVACY_POLICY}</ReactMarkdown>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
